module.exports = __webpack_public_path__ + "img/download-white.067bd08e.svg";